import { RouteRecordRaw } from 'vue-router';
import { DashboardPage } from '@/pages/dashboard';

export const routeName = 'Dashboard';

export const route: RouteRecordRaw = {
  path: 'dashboard',
  name: routeName,
  component: DashboardPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Dashboard',
    permissions: [{ action: 'read', subject: 'Admin' }],
  },
};
